import React from "react";
import { LoadingState, SendSubmissionResponse } from "@/types/fitconnect.ts";

interface ResponseViewerProps {
  response: SendSubmissionResponse;
  status: LoadingState;
}

function mapStatus(status: LoadingState): string {
  switch (status) {
    case "initial":
      return "Ergebnis";
    case "pending":
      return "Sende ...";
    case "success":
      return "Erfolgreich versendet";
    case "error":
      return "Fehler";
  }
}

const ResponseViewer = ({ response, status }: ResponseViewerProps) => {
  const header = mapStatus(status);

  return (
    <section className="card shadow-sm bg-white">
      <div className="p-6 pb-3 flex items-center justify-between">
        <h3 className="text-lg font-semibold">{header}</h3>
      </div>

      <div className="p-6 pt-0 flex-1">
        {response == null ? (
          <div className="text-center p-8 text-muted-foreground">
            Keine Daten verfügbar
          </div>
        ) : (
          <pre className="whitespace-pre-wrap break-words rounded-md bg-base-300 p-4 text-sm leading-6 overflow-auto max-h-[28rem]">
            {JSON.stringify(response, null, 2)}
          </pre>
        )}
      </div>
    </section>
  );
};

export default ResponseViewer;
